import React, { useState, Fragment } from "react";

import { IconButton, CircularProgress, Icon } from "@material-ui/core";

import ArtApi from "../../api/ArtApi";

import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";

import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { Redirect } from "react-router";



function AddUser() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("@alertlabs.com");
  const [userId, setUserId] = useState<string | null>(null);

  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [error, setError] = useState<null | string>(null);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };


  const handleComplete = () => {
      setIsLoading(true);
        ArtApi.addUser(
          email
        ).then(
          result => {
            if (result.result === true) {
                setUserId(result.response)
                setIsLoading(false);
                setIsSuccess(true);
            }else{
                setSnackbarOpen(true);
                setIsLoading(false);
                setError("An unknown error occured");
            }
          }
        ).catch(error => {
            setSnackbarOpen(true);
            setIsLoading(false);
            setError(error.message);
      })
  };

  if(userId === null){

    return (

      <Fragment>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
        >
          <SnackbarContent
            className="errorSnackbar"
            message={
              <span id="message-id" className="snackbarMessage">
                  <Icon className="snackbarIcon">
                  error
                  </Icon>
                  {error}
              </span>
            }
            action={[
              <IconButton
                key="close"
                aria-label="close"
                color="inherit"
                onClick={handleSnackbarClose}
              >
                <Icon>
                cancel
                </Icon>
              </IconButton>
            ]}
          />
        </Snackbar>

        {isLoading ? (
          <CircularProgress size={24} />
        ) : (
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            onClick={handleDialogOpen}
          >
            <Icon>
                group_add
            </Icon>
          </IconButton>
        )}

        <Dialog
          open={isDialogOpen}
          onClose={handleDialogClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            Add User
          </DialogTitle>
          <DialogContent>
            <DialogContentText>Add User E-mail</DialogContentText>
              <TextField
                id="email"
                label="E-Mail"
                value={email}
                onChange={e => setEmail(e.target.value)}
                margin="normal"
                fullWidth={true}
              />

          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleDialogClose}
              color="primary"
              variant="contained"
            >
              Cancel
            </Button>
            <div className="buttonWrapper">
              <Button
                onClick={handleComplete}
                color="primary"
                variant="contained"
                disabled={isLoading}
                className={isSuccess ? "buttonSuccess" : ""}
              >
                {isSuccess ? "Close" : "Create"}
              </Button>
              {isLoading && (
                <CircularProgress size={24} className="buttonProgress" />
              )}
            </div>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
              }else{
                  return (<Redirect to={"user/"+userId} />)
              }

}

export default AddUser;
